import React from 'react';
import {SliderItem, GetHandleProps} from 'react-compound-slider';

interface Props {
  domain: number[];
  handle: SliderItem;
  getHandleProps: GetHandleProps;
  color?: string;
}

export default function Handle({
  domain: [min, max],
  handle: {id, value, percent},
  getHandleProps,
  color,
}: Props) {
  return (
    <div
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: '0px',
        marginTop: '0px',
        zIndex: 2,
        width: 5,
        height: 5,
        cursor: 'pointer',
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
        backgroundColor: color ? color : '#fff',
      }}
      {...getHandleProps(id)}
    />
  );
}
